import { Text } from "components/shared/text";
import { SvgCommandAdd, SvgInfo, SvgInfoOutline, SvgSuccessInvert, SvgSupprimer } from "components/svg";
import { InputNumber } from "antd";
import { useCallback, useState } from "react";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";


interface AccProps {
    acc?: any;
    select?: (e: any) => void;
    changeQuantity?: (quantity: number) => void;
}

const Acc: React.FC<AccProps> = ({
    acc, select, changeQuantity
}) => {
    const { t } = useTranslation();
    const { network, isThermor } = useSalesNetwork();
    const [opacity, setOpacity] = useState<number>(0);

    const onMouseLeave = useCallback(() => {
        setOpacity(0);
    }, [])
    const onMouseOver = useCallback(() => {
        setOpacity(90);
    }, [])


    const itemContent = <>
        <group data-direction="column" data-contain="" data-height="autofit"
            data-index={opacity === 0 ? "2" : "1"}
        >
            <group data-background="grey-color-light">
                <picture
                    data-max-height="100"
                    data-contain=""
                    data-ratio="2:1"
                    data-object-fit="contain"
                    onClick={select}
                >{acc._accessory.photo && <img src={acc._accessory.photo} alt='' />}</picture>
                <group
                    data-position="absolute"
                    data-bottom="5"
                    data-right="5"
                    data-width="auto"
                    data-background="white"
                    data-radius="30"
                    data-space="2"
                    onMouseOver={onMouseOver}
                >
                    <icon data-svg-size="30" data-svg-color="secondary"><SvgInfo /></icon>
                </group>
            </group>

            <group data-space="15" data-height="autofit">
                <group>
                    <Text
                        data-text-size="large"
                        data-weight="500"
                        //data-color="main"
                        //data-ellipsis=""
                        data-wrap="wrap"
                    >
                        {acc?.reference}
                    </Text>
                </group>

                <group>
                    <Text
                        //data-color="main"
                        data-ellipsis=""
                    >
                        {acc?.code_env}
                    </Text>
                </group>
                {(acc?._accessory?.accessory_type || acc?._accessory?.technical_data != null) && (
                    <group data-direction="column" data-gap="3">
                        {acc?._accessory?.accessory_type && <text data-text-size="12" data-wrap="wrap">
                            {t(`ACCESSORY_TYPE_${acc._accessory.accessory_type}`)}
                        </text>}
                        {acc._accessory.technical_data != null && acc._accessory.technical_data !== "" && (
                            <text data-text-size="12">
                                {acc._accessory.technical_data}{acc._accessory.accessory_type === "ELECTRICAL_BACKUP" ? " kW" :
                                    ["BUFFER_TANK", "EXPANSION_TANK", "DECOUPLING_BOTTLE"].includes(acc._accessory.accessory_type) ? " L" : ""}
                            </text>
                        )}
                    </group>
                )}


            </group>

            <group data-direction="column" data-contain="" data-space-horizontal="20" data-justify="end" data-gap="20">
                {acc._selected ?
                    <>
                        <group data-gap="10" data-align="center" data-space-bottom="10">
                            <text>{t("QTY")}</text>
                            <InputNumber
                                aria-label={t("QTY")}
                                min={1}
                                max={99}
                                precision={0}
                                value={acc._qty ?? 0}
                                onChange={(value) => {
                                    if (value != null && Number.isSafeInteger(value) && value >= 0) {
                                        changeQuantity?.(value);
                                    }
                                }}
                            />
                        </group>
                        <group data-gap="5" data-align="center" data-justify="start">
                            <group>
                                <div className="button large secondary" data-length="autofit">
                                    <icon data-svg-size="20" data-svg-color="white"><SvgSuccessInvert /></icon>
                                    <text data-width="auto">{t("ADDED")}</text>
                                </div>

                            </group>
                            <group>
                                <div className="button large secondary simple" data-length="autofit" onClick={select}>
                                    <icon data-svg-size="20" data-svg-color="secondary"><SvgSupprimer /></icon>
                                    <text data-width="auto">{t("DELETE")}</text>
                                </div>
                            </group>
                        </group>
                    </>
                    :
                    <>
                        <separator data-horizontal="" data-margin="none"></separator>
                        <group data-gap="5" data-align="center" data-justify="start" data-space-bottom="20" >

                            <div className="button large secondary outline" data-length="forcefit" data-fit="1" onClick={select}>
                                <icon data-svg-size="20" data-svg-color="secondary"><SvgCommandAdd /></icon>
                                <text data-width="auto">{t("SELECT")}</text>
                            </div>

                        </group>
                    </>
                }

            </group>
        </group>
        <group
            data-position="absolute"
            data-height="fit"
            data-space="20"
            data-background="white"
            data-gap="10"
            data-opacity={opacity}
            data-direction="column"
            data-wrap="no"
            onMouseOut={onMouseLeave}
            data-index={opacity === 0 ? "1" : "2"}

        >
            <group>
                <icon data-svg-size="24" data-svg-color="secondary"><SvgInfoOutline /></icon>
            </group>
            <group data-height="autofit" data-gap="10" data-scroll="">

                <text data-wrap="preline">
                    {acc.description}
                </text>
            </group>
            <group>
                {!network?._parameters.hidePrice && <text data-weight="600" data-text-size="large">{acc.price}{network?._parameters.currency} {t("PPHT")}</text>}
            </group>
        </group>
    </>;

    return (
        <>
            <group
                data-direction="column"
                data-contain=""
                {...(isThermor ? {} : { "data-radius": "extra-special" })}
                {...(isThermor ? { "data-border-color": "main-color-custom-border" } : { "data-border-color": "main-color" })}
                data-background="context"
                data-cursor="pointer"
                //data-length="260"
                data-adaptive="desktop"
            >
                {itemContent}
            </group>
            <group
                data-direction="column"
                data-contain=""
                {...(isThermor ? {} : { "data-radius": "extra-special" })}
                {...(isThermor ? { "data-border-color": "main-color-custom-border" } : { "data-border-color": "main-color" })}
                data-background="context"
                data-cursor="pointer"
                //data-length="260"
                data-adaptive="mobile"
            >
                {itemContent}
            </group>
        </>
    )
}

export default Acc;